import { Link, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { Phone } from "lucide-react";
import { trackCallClick } from "@/lib/googleAds";

const links = [
  { to: "/#posts", label: "Dispatches", id: "nav-link-posts" },
  { to: "/#compare", label: "The Scorecard", id: "nav-link-compare" },
  { to: "/#faq", label: "FAQ", id: "nav-link-faq" },
  { to: "/antivirus", label: "Antivirus", id: "nav-link-antivirus" },
  { to: "/about", label: "About", id: "nav-link-about" },
];

const Nav = () => {
  const { pathname } = useLocation();
  return (
    <motion.header
      initial={{ y: -60, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
      className="fixed top-0 left-0 right-0 z-40 backdrop-blur-xl bg-[#0A0A0A]/70 border-b border-white/10"
      data-testid="site-nav"
    >
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
        <Link
          to="/"
          data-testid="nav-logo"
          className="font-oswald text-xl font-semibold tracking-[0.15em] lowercase"
        >
          onlyreviews<span className="text-[#0055FF]">.</span><span className="text-[#FF3300]">blog</span>
        </Link>
        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <Link
              key={l.id}
              to={l.to}
              data-testid={l.id}
              className="font-mono-p text-xs tracking-[0.2em] uppercase text-[#A1A1AA] hover:text-[#F5F5F5] transition-colors duration-300"
            >
              {l.label}
            </Link>
          ))}
        </nav>
        <div className="flex items-center gap-4">
          <a
            href="tel:+18884999335"
            onClick={trackCallClick("tel:+18884999335")}
            data-testid="nav-call-cta"
            className="hidden sm:flex items-center gap-2 font-oswald text-xs tracking-[0.2em] uppercase bg-[#F5F5F5] text-[#0A0A0A] px-4 py-2 hover:bg-[#0055FF] hover:text-white transition-colors duration-300"
          >
            <Phone className="w-3.5 h-3.5" /> +1 888-499-9335
          </a>
          <span className="hidden lg:block font-oswald text-xs tracking-[0.3em] uppercase text-[#A1A1AA] border border-white/10 px-3 py-1.5">
            Issue Nº 01
          </span>
        </div>
      </div>
      {pathname !== "/" && null}
    </motion.header>
  );
};

export default Nav;
